// Where this deploy lives. Dev: *.lifeable.dev.gfmhq.com on the lifeable box. Prod: *.lifeable.co.
const base = process.env.LIFEABLE_BASE_DOMAIN || "lifeable.dev.gfmhq.com";
export const hosts = {
  base,
  www: `https://${base}`,
  app: `https://app.${base}`,
  admin: `https://admin.${base}`,
};
export const brand = {
  name: "Lifeable",
  headline: "Finally, Life Organized.",
  sub: "Know what's going on. Stay in control.",
  company: "Grandfield Media",
  legalName: "Grandfield Media Private Limited",
  companyUrl: "https://grandfieldmedia.com/",
  phone: "+91 92479 12080",
  mailFrom: process.env.MAIL_FROM || "Lifeable <hello@lifeable.co>",
  supportEmail: "hello@lifeable.co",
};
export const isProd = process.env.NODE_ENV === "production" && !!process.env.LIFEABLE_PROD;
export const cookieDomain = process.env.COOKIE_DOMAIN || `.${base}`;
